import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let ProductCategoriesRestServiceConfig: IRestfulConfigMap = {
    ProductCategoriesRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getCategories: {
                method: "get",
                path: "api/productCategories/product/:productId",
                testPath: "api/productCategories/product/:productId",
                paramDefaults: {
                    "productId": "@productId"
                }
            }
            
        }
    }
}


export { ProductCategoriesRestServiceConfig };